export default __webpack_public_path__ + "assets/pentagon.5d1859e5.png";